import {
  GET_PREBOOKING_OFFERING_REQUEST,
  GET_PREBOOKING_OFFERING_SUCCESS,
  GET_PREBOOKING_OFFERING_FAILURE,
  CREATE_BOOKING_REQUEST,
  CREATE_BOOKING_SUCCESS,
  CREATE_BOOKING_FAILURE,
  UPDATE_SELECTED_LOCATION_ID,
  CHANGE_BOOKING_FROM_DATE_TIME,
  CHANGE_BOOKING_TO_DATE_TIME,
  SET_SELECT_OFFERING,
  SELECT_PARKING_OPTIONAL_SERVICE,
  CHECK_SPACE_REQUEST,
  CHECK_SPACE_FAILURE,
  CHECK_SPACE_SUCCESS
 
} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';
let moment = require('moment');


export default function homePageReducer(state = initialState.locationDetail, action) {

  switch (action.type) {
    case GET_PREBOOKING_OFFERING_REQUEST:
      return objectAssign({}, state, { isFetching: true});
    case GET_PREBOOKING_OFFERING_FAILURE:
      return objectAssign({}, state, { isFetching: false, error: action.error});
    case GET_PREBOOKING_OFFERING_SUCCESS:
    {      

      return objectAssign({}, state,{
        isFetching: false,
        selectedLocation: action.data,
        selectedOffering:action.data.offerings[0]
      });

    }
    case CREATE_BOOKING_REQUEST:
      return objectAssign({}, state, { isFetching: true});
    case CREATE_BOOKING_FAILURE:
      return objectAssign({}, state, { isFetching: false, error: action.error});
    case CREATE_BOOKING_SUCCESS:
    {

      return objectAssign({}, state,{
        isFetching: false,
        bookingDetail:action.data
      });

    } 
    case UPDATE_SELECTED_LOCATION_ID:
      return objectAssign({}, state, { selectedLocationId: action.data});

    case CHANGE_BOOKING_FROM_DATE_TIME: {
      return objectAssign({}, state, { startDate: moment(action.data).toISOString()});
    }
    case CHANGE_BOOKING_TO_DATE_TIME: {
      return objectAssign({}, state, { untilDate: moment(action.data).toISOString(),untilDateChanged:true});
    }
    case SET_SELECT_OFFERING:{

      return objectAssign({}, state, { selectedOffering: action.data});
    }
    case SELECT_PARKING_OPTIONAL_SERVICE: {
      return objectAssign({}, state, {selectedOptionalServices:action.services});
    }
    case CHECK_SPACE_REQUEST:
      return objectAssign({}, state, { isFetching: true});
    case CHECK_SPACE_FAILURE:
      return objectAssign({}, state, { isFetching: false, error: action.error});
    case CHECK_SPACE_SUCCESS:
    {      

      return objectAssign({}, state,{
        isFetching: false,
        spaceAvailable:action.data.spaceAvailable
      });

    }
   
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/homePageReducer.js